// extracted by mini-css-extract-plugin
export default {"container":"FormItem_container__HVZxR","label":"FormItem_label__e8QWT","errorLabel":"FormItem_errorLabel__vPUUi","value":"FormItem_value__aS7Mx"};